// extracted by mini-css-extract-plugin
module.exports = {"icon":"Typeahead_icon__3PIFr"};